import { useEffect, useRef, useState } from 'react';
import { LoadState } from '../../types/LoadState';
import { getFromStorage, removeStorageKey } from '../lib/storage';

export const useStoredResult = <T>(
  cacheKey: string,
  organisationsnummer: string
) => {
  const previousOrganisationsnummer = useRef<string>();
  const [loadState, setLoadState] = useState(LoadState.Idle);
  const [searchResult, setSearchResult] = useState<T>();

  useEffect(() => {
    const storedSearchResult = getFromStorage<T>(cacheKey);

    if (storedSearchResult) {
      setSearchResult(storedSearchResult);
      setLoadState(LoadState.Success);
    }
  }, []);

  useEffect(() => {
    if (
      previousOrganisationsnummer.current &&
      previousOrganisationsnummer.current !== organisationsnummer
    ) {
      removeStorageKey(cacheKey);
      setLoadState(LoadState.Idle);
      setSearchResult(undefined);
    }
    previousOrganisationsnummer.current = organisationsnummer;
  }, [organisationsnummer]);

  return {
    loadState,
    searchResult,
    setLoadState,
    setSearchResult,
  };
};
